import { Component, ElementRef, Renderer2, ViewEncapsulation, inject } from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

import {ModalType} from './modal-type.enum';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ModalComponent {
    private readonly modalService = inject(BsModalService);
    private readonly modalRef = inject(BsModalRef);
    private readonly elementRef = inject(ElementRef);
    private readonly renderer = inject(Renderer2);

    public message: string;
    public heading: string;
    public parameter?: any;
    public assignedModalType: ModalType = ModalType.Question;

    public get informativeModalType() {
        return ModalType;
    }

    public set focusPrimaryButton(value: boolean) {
        const focusedButtonId = value ? 'primary' : 'secondary';
        const focusedButton = this.elementRef.nativeElement.querySelector(`#${focusedButtonId}`);
        focusedButton.focus();
    }

    public set modalType(modalType: ModalType) {
        this.assignedModalType = modalType;
        const iconClass = this.getIconClass();
        const modalElement = this.elementRef.nativeElement.closest('.modal');
        this.renderer.addClass(modalElement, iconClass);
    }

    public dismissModal(): void {
        this.modalRef.hide();
    }

    public confirmModal(): void {
        this.modalService.setDismissReason('confirm');
        this.modalRef.hide();
    }

    private getIconClass(): string {
        switch (this.assignedModalType) {
        case ModalType.Question:
            return 'modal-help';
        case ModalType.Warning:
            return 'modal-warning';
        case ModalType.Error:
            return 'modal-error';
        case ModalType.OK:
            return 'modal-help';
        }
    }
}
